import React from 'react';
import { SBBox } from 'modules/Commons';
import { SBNewTable } from "modules/Commons/SBDataDisplays/SBTable/SBNewTable";
import useDistributionUploadErrorsHeader from './useDistributionUploadErrorsHeader';
import { useStyles } from "../style";
import { IDistributionCSVErrors } from '../DistributionCSVHandler';

interface DistributionUploaderHelperErrorProps {
    errors: IDistributionCSVErrors[];
}

const DistributionUploaderHelperError: React.FC<DistributionUploaderHelperErrorProps> = ({ errors }) => {
    const classes = useStyles();
    const { headers } = useDistributionUploadErrorsHeader();

    return (
        <SBBox className={classes.errorsTableContainer}>
            <SBNewTable
                key={errors.length}
                startRows={errors}
                defaultColumns={headers}
                onClick={() => { }}
                title={"errors"}
                disableToolbar
                virtualize
                containerHeight={295}
            />
        </SBBox>
    );
};

export default DistributionUploaderHelperError;
